import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fieldDataWithDiffsSelector,
  initializeState,
} from '../../../features/componentFeatures/renderHearingSlice';
import { getEntityId } from '../../../features/helpers/apiHelpers';
import { Field } from './renderHearing/Field';

const RenderHearing = ({
  hearing,
  isEditMode,
  disabledFieldTypes,
  disableStateInitialization,
}) => {
  disabledFieldTypes = disabledFieldTypes || [];
  if (!Array.isArray(disabledFieldTypes)) {
    disabledFieldTypes = [disabledFieldTypes];
  }
  const dispatch = useDispatch();

  useEffect(() => {
    !disableStateInitialization && dispatch(initializeState());
    return function cleanup() {
      !disableStateInitialization && dispatch(initializeState());
    };
  }, [dispatch, disableStateInitialization]);

  const hearingId = getEntityId(hearing);
  const fieldsToRender = useSelector(fieldDataWithDiffsSelector(hearingId));

  return fieldsToRender.map((field) => {
    if (disabledFieldTypes.some((fieldType) => fieldType === field.type)) {
      return null;
    }
    return <Field fieldData={field} isEditMode={isEditMode} key={field.id} />;
  });
};

export { RenderHearing };
